import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedLayout } from "../features/auth/ProtectedLayout.js";
import { PortalLayout } from "../layouts/PortalLayout.js";
import { AnalyticsPage } from "../pages/AnalyticsPage.js";
import { DashboardPage } from "../pages/DashboardPage.js";
import { InventoryPage } from "../pages/InventoryPage.js";
import { LoginPage } from "../pages/LoginPage.js";
import { NotFoundPage } from "../pages/NotFoundPage.js";
import { OrdersPage } from "../pages/OrdersPage.js";
import { ProductsPage } from "../pages/ProductsPage.js";
import { ProfilePage } from "../pages/ProfilePage.js";
import { TraceabilityPage } from "../pages/TraceabilityPage.js";
import { UsersPage } from "../pages/UsersPage.js";
import { WarehousesPage } from "../pages/WarehousesPage.js";
import { useAuth, useHasModule } from "../features/auth/AuthProvider.js";

function RequireModule({ module, children }: { module: string; children: JSX.Element }): JSX.Element {
  const has = useHasModule(module);
  /* Mientras los módulos cargan (array vacío, no bypass) → permitir para evitar parpadeo;
     el enforcement real lo hace la API devolviendo 403. */
  if (!has) return <Navigate to="/" replace />;
  return children;
}

const USERS_MANAGEMENT_ROLES = new Set(["superadmin", "platform-support", "tenant-admin"]);

function RequireUsersManagement({ children }: { children: JSX.Element }): JSX.Element {
  const { user } = useAuth();
  if (!user || !USERS_MANAGEMENT_ROLES.has(user.role)) return <Navigate to="/" replace />;
  return children;
}

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedLayout />}>
        <Route element={<PortalLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route
            path="inventory"
            element={
              <RequireModule module="inventory">
                <InventoryPage />
              </RequireModule>
            }
          />
          <Route
            path="products"
            element={
              <RequireModule module="inventory">
                <ProductsPage />
              </RequireModule>
            }
          />
          <Route
            path="warehouses"
            element={
              <RequireModule module="inventory">
                <WarehousesPage />
              </RequireModule>
            }
          />
          <Route
            path="orders"
            element={
              <RequireModule module="orders">
                <OrdersPage />
              </RequireModule>
            }
          />
          <Route path="traceability" element={<TraceabilityPage />} />
          <Route
            path="settings/users"
            element={
              <RequireUsersManagement>
                <UsersPage />
              </RequireUsersManagement>
            }
          />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
